import * as React from "react";
const SvgFiRrFish = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fish_svg__a)">
      <path
        fill="#062147"
        d="M6 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0M23.73 7.625A2.48 2.48 0 0 1 21.5 9h-4.519a42 42 0 0 1-.149 3h.368a2.746 2.746 0 0 1 2.765 3.188A3.29 3.29 0 0 1 16.729 18H15.4c-1.8 3.889-7.4 6-11.413 6a4 4 0 0 1-3.978-4.257A16.8 16.8 0 0 1 2 12.133V11.6a7.71 7.71 0 0 1 6.317-7.554 3.12 3.12 0 0 1 2.537.693A3.21 3.21 0 0 1 12 7.168c.93-.086 1.941-.129 3-.149V2.5a2.5 2.5 0 0 1 4-2 4.86 4.86 0 0 1 1.833 2.663A4.86 4.86 0 0 1 23.5 5a2.5 2.5 0 0 1 .23 2.625M4.385 9.541A13.2 13.2 0 0 1 10 7.432V7.2a1.22 1.22 0 0 0-.856-1.161 1.1 1.1 0 0 0-.479-.025 5.62 5.62 0 0 0-4.28 3.527M8.783 21.2A8.04 8.04 0 0 0 2.8 15.222 20 20 0 0 0 2 19.88 2 2 0 0 0 4.12 22c1.58-.081 3.146-.35 4.663-.8m6.209-12.192c-6.239.107-9.639 1.264-11.4 4.362a10.05 10.05 0 0 1 7.04 7.039c3.096-1.763 4.253-5.162 4.36-11.401M16.568 14q-.168 1.012-.445 2h.606a1.28 1.28 0 0 0 1.261-1.094.754.754 0 0 0-.79-.906zM21.9 6.189a3 3 0 0 0-2.06-1.2 1 1 0 0 1-.821-.821 2.99 2.99 0 0 0-1.2-2.06.5.5 0 0 0-.537-.049A.48.48 0 0 0 17 2.5V7h4.5a.48.48 0 0 0 .445-.273.5.5 0 0 0-.045-.538"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fish_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFish;
